import { render, staticRenderFns } from "./Co2Growth.vue?vue&type=template&id=d71b96ea&scoped=true"
import script from "./Co2Growth.vue?vue&type=script&lang=js"
export * from "./Co2Growth.vue?vue&type=script&lang=js"
import style0 from "./Co2Growth.vue?vue&type=style&index=0&id=d71b96ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71b96ea",
  null
  
)

export default component.exports